import Sidebar from './Sidebar';
import './AdminLayout.scss';

export default function AdminLayout({ children }) {
    return (
        <div className="admin-layout">
            <Sidebar />
            <main className="admin-layout__main">
                <div className="admin-layout__content fade-in">
                    {children}
                </div>
            </main>
        </div>
    );
}
